webpackJsonp([82905442716184],{

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookReducers = __webpack_require__(63);
	
	var _LoreHookReducers2 = _interopRequireDefault(_LoreHookReducers);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookReducers2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Specify dependencies between child reducers, which will determine the order they are called in, as well as what data is passed in through the third \'options\' argument:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      function someReducer(state, action, options) {\n        // your reducer code...\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The `options.nextState` property will contain the results of the child reducers you have declared a dependency on.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default dependency structure (based on the built-in blueprints) looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      dependencies: {\n        modelName: {\n          byId: [],\n          byCid: [],\n          find: [\'byId\', \'byCid\']\n        }\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-reducers-config-dependencies-js-9ee33d1dcdc26bd91971.js